module.exports = __webpack_public_path__ + "static/media/ovariancancer.3223fd0f.svg";